/**
 * @created on 2017/9/22
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import './style.scss'
;(function(win) {
  /**
   *
   * @param str
   * @param time
   */
  function toast(str, time = 1000, callbackFn) {
    let $root = document.body
    let $toast = $root.querySelector('.yxl-toast')

    if ($toast) {
      remove()
    }

    $toast = document.createElement('div')

    $toast.classList.add('yxl-toast')
    $toast.innerHTML = str

    $root.appendChild($toast)

    setTimeout(() => {
      remove()
      if (callbackFn) {
        callbackFn()
      }
    }, time)

    function remove() {
      if ($toast) {
        try {
          $root.removeChild($toast)
          $toast = null
        } catch (e) {}
      }
    }
  }

  win.toast = toast
})(window)



// WEBPACK FOOTER //
// ./src/public-resource/components/toast/index.js